import { render, staticRenderFns } from "./JDMatchingRow.vue?vue&type=template&id=12034942&scoped=true&"
import script from "./JDMatchingRow.vue?vue&type=script&lang=js&"
export * from "./JDMatchingRow.vue?vue&type=script&lang=js&"
import style0 from "./JDMatchingRow.vue?vue&type=style&index=0&id=12034942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12034942",
  null
  
)

export default component.exports